import React, { Component} from 'react';
import CartItem from './cartItem';
import cartStyles from './cart.module.scss';
import CartHandler from '../../services/cartService';
import ReactHtmlParser from 'react-html-parser';

class cart extends Component {

    constructor(props) {
        super(props);
        this.updateTotal.bind(this);
        this.state = {
            isLoaded: false,
            data: null,
            total_price: 0,
            message: ''
        };
    }

    async componentDidMount() {
        let res = await CartHandler.getCartItem();
        if(res.data.length > 0) {
        this.setState({
                isLoaded: (res.data.length > 0) ? true : false,
                data: res.data,
                total_price: (res.data.length > 0) ? res.data[0].total_price.formatted : 0
            })
        }else{
            this.setState({
                message: 'cart is empty'
            })
        }
    }

    updateTotal(total_price) {
        this.setState({
            total_price
        })
    }

    render() {
        const { isLoaded, total_price} = this.state;
        const cart1 = []
        
        if(isLoaded) {
            const {order_items} = this.state.data[0];
            order_items.map((cartItem, key) =>
            cart1.push(<CartItem product={cartItem} updateTotal={ this.updateTotal.bind(this)} key={key} />)
            )
        }
        if(this.state.message){
        return (
            <div>
            <h1 className={cartStyles.page__title}>Shopping cart</h1>
            <h1 className={cartStyles.cart__empty}>{this.state.message}</h1>
            </div>
        )}else{
        return (
            <header> 
              <h1 className={cartStyles.page__title}>Shopping cart</h1>
              <div className="cart">
                {cart1}
                <div className={cartStyles.cart__total}> {(isLoaded) ? ReactHtmlParser('<h3>Total : </h3><span>' + total_price + '<span>'): ''} </div>
              </div>
            </header>
        );
    }}
}

export default cart;
